import React, { useState, useEffect, useRef } from "react";
import MaskArea from "./MaskArea";
import "../../assets/css/ScreenshotPicker.css";
import { CameraFill } from "react-bootstrap-icons";

const ScreenshotPicker = (props) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [refPos, setRefPos] = useState({ x: 0, y: 0 });
    const [divSize, setDivSize] = useState({ width: 450, height: 450 });
    const [refDivSize, setRefDivSize] = useState({ width: 0, height: 0 });
    const [introEnd, setIntroEnd] = useState(false);
    const [containerExtending, setContainerExtending] = useState(false);
    const [containerDragging, setContainerDragging] = useState(false);
    
    useEffect(() => {
        setPosition({
            x: props.bodySize.width / 2 - 200 >= 0
                ? props.bodySize.width / 2 - 200
                : 0,
            y: !props.fullScreenMode
                ? props.bodySize.height / 2 - 200
                : 0
        })
        setDivSize({
            width: !props.fullScreenMode
                ? divSize.width
                : props.bodySize.width,
            height: !props.fullScreenMode
                ? divSize.height
                : props.bodySize.height
        })        
    }, []);

    const prevPropsRef = useRef(props);
    useEffect(() => {
        if (!containerExtending && containerDragging) {
            if (prevPropsRef.current.mousePos !== props.mousePos) {
                setNewContainerPosition();
            }
        } else if (containerExtending && !containerDragging) {
            if (prevPropsRef.current.mousePos !== props.mousePos) {
                setNewContainerSize();
            }
        }
        prevPropsRef.current = props;
    }, [props]);

    const setNewContainerPosition = () => {
        let containerX = props.mousePos.x - refPos.x;
        let containerY = props.mousePos.y - refPos.y;
        let newPos = { x: containerX, y: containerY };
        setPosition(borderCollisonForMoving(newPos))
    }
    const borderCollisonForMoving = (pos) => {
        if (pos.x < 0) {
          pos.x = 0;
        }    
        if (pos.x + divSize.width > props.bodySize.width) {
          pos.x = props.bodySize.width - divSize.width;
        }    
        if (pos.y < 0) {
          pos.y = 0;
        }    
        if (pos.y + divSize.height > props.bodySize.height) {
          pos.y = props.bodySize.height - divSize.height;
        }    
        return pos;
    };

    const setNewContainerSize = () => {
        let width = refDivSize.width + (props.mousePos.x - refPos.x);
        let height = refDivSize.height + (props.mousePos.y - refPos.y);
        let newSize = { width: width, height: height };
        setDivSize(borderCollisonForExtending(newSize))
    };
    const borderCollisonForExtending = (size) => {
        if (size.width + position.x > props.bodySize.width) {
            size.width = props.bodySize.width - position.x;
        }
        if (size.height + position.y > props.bodySize.height) {
            size.height = props.bodySize.height - position.y;
        }
        return size;
    };

    const extendAreaMouseDown = (e) => {
        e.stopPropagation();
        setContainerExtending(true)
        // setContainerFocusing(true)
        setRefPos({ x: e.clientX, y: e.clientY })
        setRefDivSize(divSize)
        setIntroEnd(true)
        let msg = {
            containerExtending: true,
        };
        props.containerExtending(msg);
    };

    const extendAreaMouseUp = (e) => {
        e.stopPropagation();
        setContainerExtending(false)
        setRefPos({ x: 0, y: 0 })
        let msg = {
            containerExtending: false,
        };
        props.containerExtending(msg);
    };

    const headerMouseDown = (e) => {
        e.stopPropagation();
        // e.preventDefault();
        if (!props.fullScreenMode) {
            setContainerDragging(true)
            // setContainerFocusing(true)
            setRefPos({
                x: e.clientX - position.x,
                y: e.clientY - position.y,
            })
            setIntroEnd(true)
            let msg = {
                containerDragging: true,
            };
            props.containerDragging(msg);
        }
    };

    const headerMouseUp = (e) => {
        if (!props.fullScreenMode) {
            e.stopPropagation();
            setContainerDragging(false)
            setRefPos({ x: 0, y: 0 })
            let msg = {
                containerDragging: false,
            };
            props.containerDragging(msg);
        }
    };

    const closeScreenshotPicker = () => {
        props.closeScreenshotPicker();
    };

    const getSreenshotArea = () => {
        let msg;
        if (props.fullScreenMode) {
            msg = {
                x: 0,
                y: 0,
                width: props.bodySize.width,
                height: props.bodySize.height,
            };
        } else {
            msg = {
                x: position.x,
                y: position.y,
                width: divSize.width,
                height: divSize.height,
            };
        }
        props.getSreenshotArea(msg);
    };

    const defaultImageLayout = {
        top: position.y,
        left: position.x,
        width: divSize.width,
        height: divSize.height,
        backgroundColor: introEnd ? null : "white",
    };

    const extendFunctionAreaStyle = {
        width: "20px",
        height: "20px",
        position: "absolute",
        right: "0px",
        bottom: "0px",
        userSelect: "none",
        color: "#bede07",
        cursor: "nw-resize",
    };

    return (
      <div style={{ width: props.bodySize.width, height: props.bodySize.height }}>
        <div className={"ScreenshotPickerContainer"} style={defaultImageLayout}
          onMouseDown={headerMouseDown} onMouseUp={headerMouseUp} >
          <div style={{ display: "flex" }}>
            <div>
              <div className={"ScreenshotPickerContainerButton"} style={{ lineHeight: "30px" }} 
                onClick={closeScreenshotPicker}> X </div>
              <div className={"ScreenshotPickerContainerButton"} style={{ lineHeight: "27px" }}
                onClick={getSreenshotArea}> <CameraFill /> </div>
            </div>
            {introEnd ? null : (
              <div style={{ width: "100%" }}>
                <div style={{ padding: "30px 30px 30px 0px", fontSize: "20px", width: "100%", textAlign: "center" }}>
                  {"截圖問題回報操作說明"}
                </div>
              </div>
            )}
          </div>
          {props.fullScreenMode ? (
            <div>
              <div className={"ScreenshotPickerContainerText"}>
                {"1. 請先截圖後，繼續問題回報流程"}
              </div>
              <div className={"ScreenshotPickerContainerText"}>
                {"2. 按左側"} <CameraFill /> {"按鈕完成截圖。"}
              </div>
              <div className={"ScreenshotPickerContainerText"}>
                {"3. 截圖範圍為視窗大小"}
              </div>
              <div className={"ScreenshotPickerContainerText"}>
                {'4. 若要放棄截圖回報，按左側 "X" 按鈕取消。'}
              </div>
            </div>
          ) : introEnd ? null : (
            <div>
              <div className={"ScreenshotPickerContainerText"}>
                {"1."}
                <span style={{ fontWeight: "bolder", color: "black" }}>
                  {"這個框框是可以移動得喔!"}
                </span>
                {" (按住滑鼠左鍵不放，然後移動滑鼠)。"}
              </div>
              <div className={"ScreenshotPickerContainerText"}>
                {"2. 指標移置框框右下角，按住後滑鼠左鍵不放，然後移動滑鼠就可以"}
                <span style={{ fontWeight: "bolder", color: "black" }}>
                  {"放大縮小截圖區域。"}
                </span>
              </div>
              <div className={"ScreenshotPickerContainerText"}>
                {"3. 把框框移動到想截圖得區域後，按左側"}
                <CameraFill />
                {"按鈕完成截圖。"}
              </div>
              <div className={"ScreenshotPickerContainerText"}>
                {"4. 隨後，請繼續填寫回報單欄位：問題類型、問題敘述、提問者姓名，完成問題回報"}
              </div>
              <div className={"ScreenshotPickerContainerText"}>
                {'5. 若要放棄截圖回報，按左側 "X" 按鈕取消。'}
              </div>
            </div>
          )}
          {props.fullScreenMode ? null : (
            <div style={extendFunctionAreaStyle} onMouseDown={extendAreaMouseDown} onMouseUp={extendAreaMouseUp}>
              &#9499;
            </div>
          )}
        </div>
        <MaskArea dynamicImageSize={props.bodySize} floatWinPos={position} floatWinSize={divSize} />
      </div>
    );
}

export default ScreenshotPicker;
